// Port of api/fuel/app/classes/insights/players/mostplays.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'mostplays',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['mostplays'],
	run: function(type, owner, userIndex, detail) {
		var players = Util.sort_by_field(this._data.players || [], 'totalPlays', 'desc')
		var limit = detail ? 250 : 5
		var list = []

		if (players.length > limit) players = players.slice(0, limit)

		for (var i = 0; i < players.length; i++) {
			list.push({
				id: parseInt(players[i].id, 10) || 0,
				slug: players[i].slug,
				name: players[i].primaryName,
				username: players[i].username,
				date: parseInt(players[i].dateLast, 10) || 0,
				count: players[i].totalPlays
			})
			if (players[i].id) this._references.users.push(parseInt(players[i].id, 10))
		}

		return {
			mostplays: list
		}
	}
})
